import { useState, useEffect } from 'react';
import { Link } from 'react-router';
import {
  hasConsented,
  acceptAll,
  acceptEssentialOnly,
  setCookiePreferences,
  getCookiePreferences,
  type CookiePreferences,
} from '../lib/cookie-consent';

export function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const [showCustomize, setShowCustomize] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const [errorTracking, setErrorTracking] = useState(false);

  useEffect(() => {
    if (!hasConsented()) {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  function handleAcceptAll() {
    acceptAll();
    setVisible(false);
  }

  function handleEssentialOnly() {
    acceptEssentialOnly();
    setVisible(false);
  }

  function handleSaveCustom() {
    setCookiePreferences({ essential: true, analytics, errorTracking });
    setVisible(false);
  }

  return (
    <div className="fixed inset-x-0 bottom-0 z-[100] p-4">
      <div
        className="mx-auto max-w-2xl rounded-2xl border bg-white p-5 shadow-2xl"
        style={{ fontFamily: 'var(--font-secondary)' }}
      >
        <p className="mb-3 text-sm">
          Folosim cookies pentru a asigura funcționarea platformei. Cookies de analytics și monitorizare erori
          sunt opționale și necesită consimțământul tău.{' '}
          <Link to="/cookies" className="text-[var(--vivid-purple)] underline">
            Detalii
          </Link>
        </p>

        {showCustomize ? (
          <div className="mb-4 space-y-3">
            <label className="flex items-center gap-3 text-sm">
              <input type="checkbox" checked disabled className="h-4 w-4 rounded accent-[var(--vivid-purple)]" />
              <span><strong>Esențiale</strong> — mereu active (autentificare, sesiune)</span>
            </label>
            <label className="flex items-center gap-3 text-sm">
              <input
                type="checkbox"
                checked={analytics}
                onChange={(e) => setAnalytics(e.target.checked)}
                className="h-4 w-4 rounded accent-[var(--vivid-purple)]"
              />
              <span><strong>Analytics</strong> — Google Analytics (GA4), analiza traficului</span>
            </label>
            <label className="flex items-center gap-3 text-sm">
              <input
                type="checkbox"
                checked={errorTracking}
                onChange={(e) => setErrorTracking(e.target.checked)}
                className="h-4 w-4 rounded accent-[var(--vivid-purple)]"
              />
              <span><strong>Monitorizare erori</strong> — Sentry, raportarea erorilor</span>
            </label>

            <div className="flex gap-2 pt-1">
              <button
                onClick={handleSaveCustom}
                className="rounded-lg bg-[var(--vivid-purple)] px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-[var(--vivid-purple)]/90"
                style={{ fontFamily: 'var(--font-primary)' }}
              >
                Salvează preferințele
              </button>
              <button
                onClick={() => setShowCustomize(false)}
                className="rounded-lg border px-4 py-2 text-sm font-medium transition-colors hover:bg-gray-50"
                style={{ fontFamily: 'var(--font-primary)' }}
              >
                Înapoi
              </button>
            </div>
          </div>
        ) : (
          <div className="flex flex-wrap gap-2">
            <button
              onClick={handleAcceptAll}
              className="rounded-lg bg-[var(--vivid-purple)] px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-[var(--vivid-purple)]/90"
              style={{ fontFamily: 'var(--font-primary)' }}
            >
              Acceptă toate
            </button>
            <button
              onClick={handleEssentialOnly}
              className="rounded-lg border px-4 py-2 text-sm font-medium transition-colors hover:bg-gray-50"
              style={{ fontFamily: 'var(--font-primary)' }}
            >
              Doar esențiale
            </button>
            <button
              onClick={() => setShowCustomize(true)}
              className="rounded-lg border px-4 py-2 text-sm font-medium transition-colors hover:bg-gray-50"
              style={{ fontFamily: 'var(--font-primary)' }}
            >
              Personalizează
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
